import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import App from "./pages/App";
import { Loading } from "./pages/App/loading";
import Popup from "./pages/App/popup";
import Attribute from "./pages/Attribute";
import AddAttribute from "./pages/Attribute/AddAttribute";
import EditAttribute from "./pages/Attribute/EditAttribute";
import AttributeGroup from "./pages/AttributeGroup";
import AddAttributeGroup from "./pages/AttributeGroup/AddAttributeGroup";
import EditAttributeGroup from "./pages/AttributeGroup/EditAttributeGroup";
import AttributeValue from "./pages/AttributeValue";
import AddAttributeValue from "./pages/AttributeValue/AddAttributeValue";
import EditAttributeValue from "./pages/AttributeValue/EditAttributeValue";
import Banner from "./pages/Banner";
import BannerManage from "./pages/Banner/Manage";
import Brand from "./pages/Brand";
import BrandManage from "./pages/Brand/BrandManage";
import Car from "./pages/Car";
import CarManage from "./pages/Car/CarManage";
import Category from "./pages/Category";
import CategoryManage from "./pages/Category/CategoryManage";
import DashBlog from "./pages/DashBlog";
import AddDashBlog from "./pages/DashBlog/AddDashBlog";
import EditDashBlog from "./pages/DashBlog/EditDashBlog";
import Menu from "./pages/Menu";
import AddMenu from "./pages/Menu/AddMenu";
import EditMenu from "./pages/Menu/EditMenu";
import Orders from "./pages/Order";
import Bill from "./pages/Order/Bill";
import OrderManage from "./pages/Order/OrderManage";
import Product from "./pages/Product";
import AddProduct from "./pages/Product/AddProduct";
import Inventory from "./pages/Product/Inventory";
import PriceList from "./pages/Product/PriceList";
import ProductManage from "./pages/Product/Manage";
import PreProducts from "./pages/Product/PreProducts";
import Role from "./pages/Role";
import RoleMange from "./pages/Role/RoleManage";
import Tag from "./pages/Tag";
import AddTag from "./pages/Tag/AddTag";
import EditTag from "./pages/Tag/EditTag";
import AddUser from "./pages/User/AddUser";
import EditUser from "./pages/User/EditUser";
import UserManage from "./pages/User/UserManage";
import UsersList from "./pages/User/UsersList";
import Login from "./pages/Login";
import reportWebVitals from "./reportWebVitals";
import store from "./services/store";
import ArticleCategory from "./pages/ArticleCategory";
import AddArticleCategoy from "./pages/ArticleCategory/AddArticleCategory";
import EditArticleCategory from "./pages/ArticleCategory/EditArticleCategory";
import OrderInvoice from "./pages/Order/OrderInvoice";
import OrderManageWarehouse from "./pages/Order/OrderManageWarehouse";
import Shelves from "./pages/Shelves"; // Import the new Shelves component
import Sms from "./pages/Sms";
import AnalyticsOverview from "./pages/Analytics/Overview";
import AnalyticsUsers from "./pages/Analytics/Users";
import AnalyticsUserDetail from "./pages/Analytics/UserDetail";
import AnalyticsOrders from "./pages/Analytics/Orders";
import AnalyticsProducts from "./pages/Analytics/Products";
import AnalyticsProductDetail from "./pages/Analytics/ProductDetail";
import Invitation from "./pages/Invitation";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
    <BrowserRouter basename="/">
      <Routes>
        <Route path="" element={<Navigate to="/analytics" replace />} />
        <Route path="login" element={<Login />} />
        <Route path="tag">
          <Route path="" element={<Tag />} />
          <Route path="add" element={<AddTag />} />
          <Route path="edit/:id" element={<EditTag />} />
        </Route>
        <Route path="dashblog">
          <Route path="" element={<DashBlog />} />
          <Route path="add" element={<AddDashBlog />} />
          <Route path="edit/:id" element={<EditDashBlog />} />
        </Route>
        <Route path="banner">
          <Route path="" element={<Banner />} />
          <Route path="add" element={<BannerManage />} />
          <Route path="edit/:id" element={<BannerManage />} />
        </Route>
        <Route path="articleCategory">
          <Route path="" element={<ArticleCategory />} />
          <Route path="add" element={<AddArticleCategoy />} />
          <Route path="edit/:id" element={<EditArticleCategory />} />
        </Route>
        <Route path="bill">
          <Route path="" element={<Bill />} />
        </Route>
        <Route path="menu">
          <Route path="" element={<Menu />} />
          <Route path="add" element={<AddMenu />} />
          <Route path="edit/:id" element={<EditMenu />} />
        </Route>
        <Route path="brand">
          <Route path="" element={<Brand />} />
          <Route path="add" element={<BrandManage />} />
          <Route path="edit/:id" element={<BrandManage />} />
        </Route>
        <Route path="attributeGroup">
          <Route path="" element={<AttributeGroup />} />
          <Route path="add" element={<AddAttributeGroup />} />
          <Route path="edit/:id" element={<EditAttributeGroup />} />
        </Route>
        <Route path="attributeValue">
          <Route path="" element={<AttributeValue />} />
          <Route path="add" element={<AddAttributeValue />} />
          <Route path="edit/:id" element={<EditAttributeValue />} />
        </Route>
        <Route path="Category">
          <Route path="" element={<Category />} />
          <Route path="add" element={<CategoryManage />} />
          <Route path="edit/:id" element={<CategoryManage />} />
        </Route>
        <Route path="analytics">
          <Route path="" element={<AnalyticsOverview />} />
          <Route path="users" element={<AnalyticsUsers />} />
          <Route path="users/:id" element={<AnalyticsUserDetail />} />
          <Route path="orders" element={<AnalyticsOrders />} />
          <Route path="products" element={<AnalyticsProducts />} />
          <Route path="products/:id" element={<AnalyticsProductDetail />} />
        </Route>
        <Route path="order">
          <Route path="" element={<Orders />} />
          <Route path="edit/:id" element={<OrderManage />} />
          <Route path="edit/warehouse/:id" element={<OrderManageWarehouse />} />
          <Route path="add" element={<OrderManage />} />
          <Route path="invoice/:id" element={<OrderInvoice />} />
        </Route>
        <Route path="attribute">
          <Route path="" element={<Attribute />} />
          <Route path="add" element={<AddAttribute />} />
          <Route path="edit/:id" element={<EditAttribute />} />
        </Route>
        <Route path="product">
          <Route path="" element={<Product />} />
          <Route path="add" element={<ProductManage />} />
          <Route path="pre" element={<PreProducts />} />
          <Route path="inventory" element={<Inventory />} />
          <Route path="prices" element={<PriceList />} />
          <Route path="edit/:id" element={<ProductManage />} />
        </Route>
        <Route path="shelves" element={<Shelves />} />
        <Route path="user">
          <Route path="" element={<UsersList />} />
          <Route path="add" element={<UserManage />} />
          <Route path="edit/:id" element={<UserManage />} />
        </Route>
        <Route path="role">
          <Route path="" element={<Role />} />
          <Route path="add" element={<RoleMange />} />
          <Route path="edit/:id" element={<RoleMange />} />
        </Route>
        <Route path="car">
          <Route path="" element={<Car />} />
          <Route path="add" element={<CarManage />} />
          <Route path="edit/:id" element={<CarManage />} />
        </Route>
        <Route path="sms" element={<Sms />} />
        <Route path="invitation" element={<Invitation />} />
      </Routes>
      <Popup />
      <Loading />
    </BrowserRouter>
  </Provider>,
);

// If you want to start measuring performance in your App, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
